{
  "version": 1,
  "asset_id": "bc744520-8997-43ec-87f0-170b00dfa8f7",
  "project_id": "81864b6f-53ca-42c2-811b-21ffcbfd0515",
  "url": "/__l5e/assets-v1/bc744520-8997-43ec-87f0-170b00dfa8f7/zaha.webp",
  "r2_key": "a/v1/81864b6f-53ca-42c2-811b-21ffcbfd0515/bc744520-8997-43ec-87f0-170b00dfa8f7/zaha.webp",
  "original_filename": "zaha.webp",
  "size": 161628,
  "content_type": "image/webp",
  "created_at": "2026-07-13T07:04:20Z"
}
